import { Component, OnInit, KeyValueDiffers, DoCheck, ViewContainerRef } from '@angular/core';
import { UsersService } from "./users.service";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from "@angular/router";
import { AppService } from "../app.service";

declare var $;


@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  providers: [
    UsersService
  ]
})
export class UsersComponent implements OnInit {

  title: string;

  isLoading: boolean;
  filterParams: any;
  totalPage: number;
  usersList: any;
  user: any = {};
  totalElements: number;
  modal: any = {};
  currentUser: any = {};
  //watch variable change
  differ: any;
  constructor(
    private usersService: UsersService,
    private differs: KeyValueDiffers,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    private router: Router,
    private appService: AppService
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.differ = this.differs.find({}).create();
  }

  ngOnInit() {
    this.title = "Users";
    this.filterParams = {
      size: 10,
      page: 0
    };
    this.currentUser = this.appService.getCurrentUser();
  }

  ngDoCheck() {
    var change = this.differ.diff(this.filterParams);
    if (change) {
      if (this.filterParams.page < 0) {
        this.filterParams.page = 0;
        return;
      } else if (this.filterParams.page > this.totalPage - 1) {
        this.filterParams.page = this.totalPage - 1;
        return;
      }
      this.getUsersList();
    }
  }

  getUsersList() {

    this.isLoading = true;
    this.usersService.getUsersList(this.filterParams)
      .then(res => {
        if (res.status === 1) {
          this.usersList = res.data.dataList;
          this.totalElements = res.data.totalElements;
          this.initPaginate();
        } else {
          this.toastr.error(res.message, 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        this.isLoading = false;
      })
      .catch(err => console.log(err));
  }

  //init paging 
  initPaginate() {
    this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
    let arrPagingNumber = [];
    for (let i = 0; i < this.totalPage; i++) {
      arrPagingNumber.push(i);
    }
    return arrPagingNumber;
  }

  initModal(state, user: any = {}) {

    switch (state) {
      case 'create': {
        this.modal = {
          title: 'Create User',
          btnName: 'Create',
          state: state
        };
        this.user = {};
      }
        break;
      case 'edit': {
        this.modal = {
          title: 'Edit User',
          btnName: 'Save',
          state: state
        };
        this.user = {
          "id": user.adminId,
          "active": user.active,
          "email": user.email,
          "password": "",
          "role": user.role
        };
      }
        break;
    }
    $('#myModal').modal('show');
  }

  onSubmit(formUser) {
    this.isLoading = true;
    switch (this.modal.state) {
      case 'create': {
        this.usersService.createUser(formUser.value)
          .then(res => {
            if (res.status === 1) {
              this.toastr.success(res.message, 'Success!');
              this.getUsersList();
              $('#myModal').modal('hide');
            } else {
              this.toastr.error(res.message, 'Error!');
              if (res.errorCode === 3000) {
                localStorage.setItem("alert", JSON.stringify(res.message));
                this.router.navigate(['login']);
              }
            }
            this.isLoading = false;
          })
          .catch(err => console.log(err));
      } break;
      case 'edit': {
        this.usersService.editUser(formUser.value)
          .then(res => {
            if (res.status === 1) {
              this.toastr.success(res.message, 'Success!');
              this.getUsersList();
              $('#myModal').modal('hide');
            } else {
              this.toastr.error(res.message, 'Error!');
              if (res.errorCode === 3000) {
                localStorage.setItem("alert", JSON.stringify(res.message));
                this.router.navigate(['login']);
              }
            }
            this.isLoading = false;
          })
          .catch(err => console.log(err));
      } break;
    }
  }

  deleteUser(user: any) {
    if (confirm("Delete " + user.email + ' ?')) {
      this.isLoading = true;
      this.usersService.deleteUser(user.adminId)
        .then(res => {
          if (res.status === 1) {
            this.toastr.success(res.message, 'Success!');
            this.getUsersList();
          } else {
            this.toastr.error(res.message, 'Error!');
            if (res.errorCode === 3000) {
              localStorage.setItem("alert", JSON.stringify(res.message));
              this.router.navigate(['login']);
            }
          }
          this.isLoading = false;
        })
        .catch(err => console.log(err));
    }
  }

  activeUser(user: any, ckb){
    this.user = {
      "id": user.adminId,
      "active": ckb.checked,
      "email": user.email,
      "password": "",
      "role": user.role
    };
    this.usersService.editUser(this.user)
    .then(res => {
      if (res.status === 1) {
        this.toastr.success(res.message, 'Success!');
      } else {
        ckb.checked = !ckb.checked;
        this.toastr.error(res.message, 'Error!');
        if (res.errorCode === 3000) {
          localStorage.setItem("alert", JSON.stringify(res.message));
          this.router.navigate(['login']);
        }
      }
      this.isLoading = false;
    })
    .catch(err => console.log(err));
  }

}



// WEBPACK FOOTER //
// /build/client-cms/src/app/users/users.component.ts